import React, { useState } from 'react';
import './NewsletterEmailPreview.css';

/**
 * Vista previa fiel del email dentro de un <iframe srcDoc> (aísla estilos).
 * Toggles: Desktop (600px) / Mobile (~390px) y fondo oscuro para simular
 * el modo oscuro de los clientes de correo. Carga diferida (loading="lazy").
 */
const NewsletterEmailPreview = ({
  html,
  onFullScreen,
  defaultView = 'desktop',
  height = 540,
  compact = false,
  fill = false
}) => {
  const [view, setView] = useState(defaultView);
  const [dark, setDark] = useState(false);
  const isMobile = view === 'mobile';
  const srcDoc =
    html && html.trim()
      ? html
      : '<p style="font-family:Arial,sans-serif;padding:24px;color:#64748b">Sin contenido para mostrar.</p>';

  return (
    <div className={`np-preview ${dark ? 'np-preview-dark' : ''} ${compact ? 'np-preview-compact' : ''} ${fill ? 'np-preview-fill' : ''}`}>
      <div className="np-preview-toolbar">
        <div className="np-preview-tabs">
          <button
            type="button"
            className={`np-preview-tab ${!isMobile ? 'active' : ''}`}
            onClick={() => setView('desktop')}
          >
            🖥️ Gmail Desktop
          </button>
          <button
            type="button"
            className={`np-preview-tab ${isMobile ? 'active' : ''}`}
            onClick={() => setView('mobile')}
          >
            📱 Mobile
          </button>
        </div>
        <div className="np-preview-tools">
          <button
            type="button"
            className={`np-preview-tool ${dark ? 'active' : ''}`}
            onClick={() => setDark((d) => !d)}
            title="Simular fondo oscuro del cliente de correo"
          >
            🌙 Oscuro
          </button>
          {onFullScreen && (
            <button type="button" className="np-preview-tool" onClick={onFullScreen} title="Pantalla completa">
              🖵
            </button>
          )}
        </div>
      </div>
      <div className="np-preview-stage" style={fill ? undefined : { height: `${height}px` }}>
        <iframe
          title="Vista previa del email"
          className={`np-preview-frame ${isMobile ? 'np-preview-frame-mobile' : ''}`}
          srcDoc={srcDoc}
          loading="lazy"
          sandbox=""
        />
      </div>
    </div>
  );
};

export default NewsletterEmailPreview;
